import React from "react";
import BuySell from "../shared/BuySell";
import Validate from "../shared/validation/Validate";

const BuyingCurrency = () => {
    return (
        <Validate>
            <div className="">
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Buying Currency</h1> */}
                    <BuySell payment={false} />
                </div>
            </div>
        </Validate>
    )
}

export default BuyingCurrency;